import { render, staticRenderFns } from "./Flag.vue?vue&type=template&id=5435994f"
import script from "./Flag.vue?vue&type=script&lang=ts"
export * from "./Flag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports